
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/hotels",
      function () {
        return require("private-next-pages/special-offers/hotels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-offers/hotels"])
      });
    }
  